import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor, HttpErrorResponse } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError, first, tap } from 'rxjs/operators';
import { AuthenticationService } from '../_services/authentication.service';
import { Router, RouterStateSnapshot } from '@angular/router';
import { StateService } from '../_services/state.service';
import { FcmService } from '../_services/fcm.service';

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {
    constructor(
        private authenticationService: AuthenticationService,
        private fcmService: FcmService,
        private stateService: StateService,
        private router: Router
    ) {}

    intercept(
        request: HttpRequest<any>,
        next: HttpHandler
    ): Observable<HttpEvent<any>> {
        return next.handle(request)
            .pipe(
                tap({
                    complete: () => {
                        this.authenticationService.accessDeniedCount = 0;
                    }  
                })
            )
            .pipe(
                catchError(err => {
                    if ([401].includes(err.status) && this.authenticationService.userValue) {
                        this.authenticationService.accessDeniedCount++;
                        
                        if (this.authenticationService.accessDeniedCount >= 20) {
                            this.authenticationService.accessDeniedCount = 0;

                            this.stateService.clear();
                            // this.fcmService.clear();
                            this.authenticationService.logout();

                        }

                        if (this.authenticationService.accessDeniedCount == 3) {
                            // this.authenticationService.accessDeniedCount = 0;
                            this.authenticationService
                                .refreshToken(false)
                                .pipe(first())
                                .subscribe({
                                    next: () => {

                                    },
                                    error: error => {
                                        this.stateService.clear();
                                        this.authenticationService.softLogout();
                                    }
                                });
                            
                        }
                    }

                    if ([403].includes(err.status) && this.authenticationService.userValue) {
                        if (request.url.indexOf('login_check') > -1) {
                            this.router.navigate(['/email-non-confirme']);
                        }
                    }

                    let errMsg: string;
                    if (err instanceof HttpErrorResponse) {
                        const errm = err.message || JSON.stringify(err.error);
                        errMsg = `${err.status} - ${err.statusText || ''} Details: ${errm}`;
                    } else {
                        errMsg = err.message ? err.message : err.toString();
                    }
                    
                    return throwError(err);
                })
            );
    }
}
